import React, { useEffect } from 'react';

interface LocationModalProps {
  // Keine Props benötigt, da das Modal über DOM-Elemente gesteuert wird
}

export const LocationModal: React.FC<LocationModalProps> = () => {
  useEffect(() => {
    // Event-Listener für Modal-Öffnung
    const handleModalShow = () => {
      const locationModal = document.getElementById('locationModal');
      if (!locationModal) return;
      
      // Event-Listener für Modal-Show-Event
      locationModal.addEventListener('show.bs.modal', (event: any) => {
        // Button, der das Modal geöffnet hat
        const button = event.relatedTarget;
        if (!button) return;
        
        // Daten aus dem Button auslesen
        const locationName = button.getAttribute('data-location-name') || '';
        const street = button.getAttribute('data-street') || '';
        const houseNumber = button.getAttribute('data-house-number') || '';
        const postalCode = button.getAttribute('data-postal-code') || '';
        const city = button.getAttribute('data-city') || '';
        const country = button.getAttribute('data-country') || '';
        
        // Adresse zusammenbauen für Anzeige
        const fullAddress = `${locationName}, ${street} ${houseNumber}, ${postalCode} ${city}, ${country}`;
        
        // Adresse im Modal anzeigen
        const eventAddressElement = document.getElementById('eventAddress');
        if (eventAddressElement) {
          eventAddressElement.textContent = fullAddress;
        }
        
        // Google Maps URL für iframe-Erstellung
        const mapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}&output=embed`;
        
        // Karte im Modal einbetten
        const mapElement = document.getElementById('map');
        if (mapElement) {
          mapElement.innerHTML = `<iframe src="${mapsUrl}" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>`;
        }
      });
    };
    
    // Modal-Event-Listener initialisieren
    handleModalShow();
    
    return () => {
      // Event-Listener Cleanup würde hier stattfinden
      const locationModal = document.getElementById('locationModal');
      if (locationModal) {
        locationModal.removeEventListener('show.bs.modal', () => {});
      }
    };
  }, []);
  
  return (
    <div className="modal fade" id="locationModal" tabIndex={-1} aria-labelledby="locationModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="locationModalLabel">Event Location</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <p id="eventAddress"></p>
            <div id="map" style={{ height: '300px', width: '100%' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};
